module.exports = __webpack_public_path__ + "static/media/desmosActivity.19184fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desmosActivity.png
// module id = 1729
// module chunks = 2